<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import MissionVisionValues from "../components/MissionVisionValues.svelte";
	import LookInside from "../components/LookInside.svelte";
	import aboutTranslations from "../components/About/CareerStudentsAbout.translations.json";
	import About from "../components/About/About.svelte";
	import { getTranslate } from "../utils/getTranslate";
	import translations from "./CareerStudents.translations.json";
	import { flyInOnScroll } from "../utils/flyInOnScroll";
	import CareerStudentBanners from "../components/CareerStudentBanners.svelte";
	import StaticPicture from "../components/Picture/StaticPicture.svelte";
	import partnerKolofik from "../assets/images/partners/kolofik.png?webp&h=58&imagetools";
	import partnerOAOpava from "../assets/images/partners/obchodni-akademie-opava.png?webp&h=58&imagetools";
	import partnerBruntal from "../assets/images/partners/spsao-bruntal.png?webp&h=58&imagetools";
	import partnerKrnov from "../assets/images/partners/ssp-krnov.png?webp&h=58&imagetools";
	import partnerOpava from "../assets/images/partners/sspu-opava.png?webp&h=58&imagetools";
	import partnerBata from "../assets/images/partners/univerzita-tomase-bati.png?webp&h=58&imagetools";
	import partnerVoskop from "../assets/images/partners/voskop.png?webp&h=58&imagetools";
	import partnerVsb from "../assets/images/partners/vsb.png?webp&h=58&imagetools";
	import CareerFormBanner from "../components/CareerFormBanner.svelte";
	import CareerBannerJuricek from "../components/CareerBannerJuricek.svelte";
	import PeopleSlider from "../components/PeopleSlider.svelte";
	import HeroBanner from "../components/HeroBanner.svelte";
	import careerStudentsHeroImage from "../assets/images/career-students-hero.jpg?webp&h=1920&imagetools";

	const translate = getTranslate(translations);

	const partnerSchools = [
		{ width: 382.5, height: 58, image: partnerKrnov, alt: "SSP Krnov" },
		{ width: 200, height: 58, image: partnerKolofik, alt: "Kolofík" },
		{ width: 223, height: 58, image: partnerOAOpava, alt: "Obchodní akademie Opava" },
		{ width: 292, height: 58, image: partnerBruntal, alt: "SPŠ a OA Bruntál" },
		{ width: 432.3, height: 58, image: partnerBata, alt: "Univerzita Tomáše Bati" },
		{ width: 278, height: 58, image: partnerOpava, alt: "SSPU Opava" },
		{ width: 175, height: 58, image: partnerVsb, alt: "VŠB-TUO" },
		{ width: 307, height: 58, image: partnerVoskop, alt: "VOSKOP" },
	];

	const people = [
		{
			name: {
				cs: "Filip Klemens – Systémový administrátor",
				en: "Filip Klemens – System Administrator",
			},
			perex: {
				cs: "Ze školy a bez zkušeností rovnou do gigantu jménem BRANO",
				en: "Straight from school and without any experience, I joined the giant that is BRANO.",
			},
			description: {
				cs: "Brano mi dalo příležitost při studiu absolvovat odbornou praxi. Po ukončení studia mi BRANO nabídlo jistotu v podobě plného úvazku na IT oddělení. Byla to nabídka, která se neodmítá. Firma se postarala o kvalitní zaškolení a doteď se můžu spolehnout na své zkušené kolegy, kteří jsou mi dobrými rádci a mentory. Brano mi pomohlo nastartovat profesní život. ",
				en: "BRANO gave me the opportunity to complete a professional internship while studying. After finishing my studies, BRANO offered me a secure full-time position in the IT department. It was an offer I couldn't refuse. The company provided thorough training, and to this day, I can rely on my experienced colleagues who serve as excellent advisors and mentors. BRANO helped me kickstart my professional career.",
			},
		},
		{
			name: {
				cs: "Martin Heinz – specialista povrchových úprav",
				en: "Martin Heinz – Surface Treatment Specialist",
			},
			perex: {
				cs: "BRANO rodinná sága",
				en: "BRANO family saga",
			},
			description: {
				cs: "Navazuji na rodinnou tradici. Kdy otec i matka celý svůj profesní život strávili v BRANO. Když jsem se rozhodoval, co budu dělat, tak BRANO byla jasná volba. Dostal jsem příležitost práce jako strojírenský dělník. Ale Brano mi dalo možnost profesního růstu a dnes jsem SPECIALISTA POVRCHOVÝCH ÚPRAV.",
				en: "I am continuing the family tradition, as both my father and mother spent their entire professional lives at BRANO. When I was deciding what career path to take, BRANO was the obvious choice. I started working as a machine operator, but BRANO provided me with opportunities for professional growth, and today I am a Surface Treatment Specialist.",
			},
		},
		{
			name: {
				cs: "Petr Vavrečka – Výkonný ředitel BRANO OTBR s.r.o.",
				en: "Petr Vavrečka – Executive Director BRANO OTBR s.r.o.",
			},
			perex: {
				cs: "",
				en: "",
			},
			description: {
				cs: "Po vysoké škole jsem nastoupil do Brana jako technolog a v průběhu 3 let jsem se přes projektové řízení vypracoval na šéfa výroby největší divize dveřních systémů. Po 2 letech operativního řízení výroby jsem dostal příležitost vést projektové řízení celého BRANO, a.s., kde jsem komunikoval téměř se všemi světovými automobilkami a řešil nové projekty. Souběžně jsem se věnoval tvorbě intralogistického systému od vstupu až po nakládání hotových dílců na kamion, což se po několikaletém plánování, cca roční výstavbě a naplnění rozpočtu necelých 100 mil. Kč podařilo. Při mém 10letém výročí ve firmě jsem se s vedením firmy dohodnul, že postoupím do Olomoucké divize jako ředitel divize tepelné techniky a jednatel dceřiné společnosti vyrábějící pedálové systémy pro japonské vozy, BRANO OTBR s.r.o.",
				en: "After graduating from university, I joined Brano as a technologist and within three years, I advanced through project management to become the head of production for the largest door systems division. After two years of managing production operations, I was given the opportunity to lead project management for the entire Brano, a.s., where I communicated with nearly all major global automakers and handled new projects. Concurrently, I worked on developing an intralogistics system from the entry of materials to the loading of finished parts onto trucks. This project, after several years of planning, approximately one year of construction, and a budget of nearly 100 million CZK, was successfully completed. On my 10th anniversary with the company, I agreed with the management to move to the Olomouc division as the director of the thermal technology division and the executive director of the subsidiary company producing pedal systems for Japanese cars, BRANO OTBR s.r.o.",
			},
		},
	];

	/* eslint-disable svelte/no-at-html-tags */
</script>

<Layout menuTextColor="text-secondary">
	<section>
		<HeroBanner
			title={translate("heroHeadline")}
			subheadline={translate("heroPerex")}
			contentClass="justify-between"
			backgroundImage={careerStudentsHeroImage}
			overlay="black"
			linkAsButton
			linkText={translate("showMore")}
		/>
	</section>

	<section>
		<About translations={aboutTranslations} />
	</section>

	<section>
		<CareerStudentBanners />
	</section>

	<section>
		<PeopleSlider {people} customBg="bg-tertiary" />
	</section>

	<CareerFormBanner />

	<section class="container py-8 lg:py-32">
		<h2 use:flyInOnScroll class="flex items-center text-xl font-semibold lg:text-2xl">
			{translate("partnersHeadline")}
		</h2>
		<div
			class="grid grid-cols-1 items-center justify-center justify-items-center gap-16 py-32 md:grid-cols-2 lg:grid-cols-4 lg:gap-16"
		>
			{#each partnerSchools as { image, width, alt, height }}
				<div use:flyInOnScroll>
					<StaticPicture {image} {alt} {width} {height} />
				</div>
			{/each}
		</div>
	</section>

	<section class="container py-8 lg:py-32">
		<CareerBannerJuricek
			isSmall
			about={translate("aboutJuricek")}
			headline={translate("juricekBannerHeadline")}
			description={translate("juricekBannerText")}
		/>
	</section>

	<MissionVisionValues />

	<section>
		<LookInside />
	</section>
</Layout>
